import * as React from 'react';
import { useMemo } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography/Typography';
import * as styles from './DebtPayoffTracker.css';
import { PayoffDebt } from '../../ducks/debtPayoff';


type CurrentPaymentsProps = {
  debts: PayoffDebt[];
  currentDebtFreeMonths: number;
};

const CurrentPayments = ({debts, currentDebtFreeMonths}: CurrentPaymentsProps) => {

  const totalMonthlyPayment = useMemo(() => {
    return debts.reduce((total: number, debt) => {
      return +total + +debt.minimum_payment;
    }, 0);
  }, [debts]);

  const noPayoff = 'With current minimum payments, you will not pay off your debt.';


  return (
    <div>
      <Typography variant='h5' style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Your Current Payments
      </Typography>
      <div className={styles.currentPaymentsContainer}>
        <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '1rem', marginTop: '1rem' }}>
          Debt Accounts
        </Typography>
        {debts.map((debt, index) => {
          if (debt.status === 'paidOff') {
            return (
              <div key={index} className={styles.currentPayment}>
                <Typography style={{ textAlign: 'center', marginBottom: '1rem' }}>
                  {debt.name}: Paid Off
                </Typography>
              </div>
            );
          }
          return (
            <div key={index} className={styles.currentPayment}>
              <Typography style={{ textAlign: 'center', marginBottom: '1rem' }}>
                {debt.name}: ${debt.minimum_payment}/month
              </Typography>
            </div>
          );
        })}
        <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', marginTop: '1rem' }}>
          Total Monthly Payments ${totalMonthlyPayment}/month
        </Typography>
        <div className={styles.debtFree}>
          {currentDebtFreeMonths <= 0 ?
            <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', color: '#d13f3f' }}>{noPayoff}</Typography> :
            <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center' }}>
              Estimated Debt Payoff: <br />
            <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', color: '#d13f3f' }}>{currentDebtFreeMonths} Months</Typography>
            </Typography>}
        </div>
      </div>
    </div>
  );
};

export default connect(null, null)(CurrentPayments);